import { render } from "./nuevoPedidoADistribuidor.vue?vue&type=template&id=1136c526&scoped=true"
import script from "./nuevoPedidoADistribuidor.vue?vue&type=script&lang=js"
export * from "./nuevoPedidoADistribuidor.vue?vue&type=script&lang=js"

import "./nuevoPedidoADistribuidor.vue?vue&type=style&index=0&id=1136c526&scoped=true&lang=css"
import "./nuevoPedidoADistribuidor.vue?vue&type=style&index=1&id=1136c526&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1136c526"]])

export default __exports__